export default "__VITE_ASSET__BR7bse9b__"